import { render } from "./FishIcon.vue?vue&type=template&id=56e49e7c&scoped=true"
import script from "./FishIcon.vue?vue&type=script&lang=js"
export * from "./FishIcon.vue?vue&type=script&lang=js"

import "./FishIcon.vue?vue&type=style&index=0&id=56e49e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e49e7c"]])

export default __exports__